'use client';
import { createStyles } from '@s7/styles';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var useStyles = createStyles((theme, { inline, breakpoints })=>{
    return {
        root: _extends({
            display: inline ? 'inline-flex' : 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }, theme.fn.responsive(breakpoints)(({ inline })=>({
                display: inline ? 'inline-flex' : 'flex'
            })))
    };
});

export { useStyles as default };
//# sourceMappingURL=Center.styles.js.map
